import type { OperationVariables } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import type { DocumentNode } from 'graphql';
import { useEffect } from 'react';

import { useWindowFocus } from '@zen/utils/hooks/useWindowFocus';

const useFocusAwarePolling = <TData, TVariables extends OperationVariables = OperationVariables>(
  document: DocumentNode,
  options: useQuery.Options<NoInfer<TData>, NoInfer<TVariables>>,
  pollInterval: number
) => {
  const result = useQuery<TData, TVariables>(document, options);

  const { refetch, startPolling, stopPolling } = result;

  const { isWindowFocused } = useWindowFocus();

  useEffect(() => {
    if (!isWindowFocused) {
      stopPolling();
    } else {
      if (!options.skip) {
        refetch?.();
      }
      startPolling(pollInterval);
    }
  }, [isWindowFocused, pollInterval, refetch, startPolling, stopPolling]);

  return result;
};

export { useFocusAwarePolling };
